// Inspi Viewer Component
export const setVersion = ({ commit }, version) => { commit('SET_VERSION', version) }
export const setUser = ({ commit }, user) => { commit('SET_USER', user) }
export const setToken = ({ commit }, token) => { commit('SET_TOKEN', token) }

// Product
export const setProductLoaded = ({ commit }, isLoaded) => { commit('SET_PRODUCT_LOADED', isLoaded) }
export const setProductName = ({ commit }, name) => { commit('SET_PRODUCT_NAME', name) }
export const setProductPrice = ({ commit }, price) => { commit('SET_PRODUCT_PRICE', price) }

// UI
export const setMenuDisplayed = ({ commit }, isDisplayed) => { commit('SET_MENU_DISPLAYED', isDisplayed) }
export const setDividersDisplayed = ({ commit }, isDisplayed) => { commit('SET_DIVIDERS_DISPLAYED', isDisplayed) }
export const setCollectionDisplayed = ({ commit }, isDisplayed) => { commit('SET_COLLECTION_DISPLAYED', isDisplayed) }

// Header
export const setHeaderAlignment = ({ commit }, alignment) => { commit('SET_HEADER_ALIGNMENT', alignment) }
export const setProductNameDisplayed = ({ commit }, isDisplayed) => { commit('SET_PRODUCT_NAME_DISPLAYED', isDisplayed) }
export const setProductPriceDisplayed = ({ commit }, isDisplayed) => { commit('SET_PRODUCT_PRICE_DISPLAYED', isDisplayed) }

// Gamepad
export const setGamepadButtonsColor = ({ commit }, color) => { commit('SET_GAMEPAD_BUTTONS_COLOR', color) }
export const setArButtonDisplayed = ({ commit }, isDisplayed) => { commit('SET_AR_BUTTON_DISPLAYED', isDisplayed) }
export const setResetButtonDisplayed = ({ commit }, isDisplayed) => { commit('SET_RESET_BUTTON_DISPLAYED', isDisplayed) }
export const setDimensionsButtonDisplayed = ({ commit }, isDisplayed) => { commit('SET_DIMENSIONS_BUTTON_DISPLAYED', isDisplayed) }
export const setScreenshotButtonDisplayed = ({ commit }, isDisplayed) => { commit('SET_SCREENSHOT_BUTTON_DISPLAYED', isDisplayed) }
export const setProjectButtonDisplayed = ({ commit }, isDisplayed) => { commit('SET_PROJECT_BUTTON_DISPLAYED', isDisplayed) }

// Screenshot
export const setFrontScreenshotEnabled = ({ commit }, isEnabled) => { commit('SET_FRONT_SCREENSHOT_ENABLED', isEnabled) }

// Project
export const setProjectCreating = ({ commit }, isCreating) => { commit('SET_PROJECT_CREATING', isCreating) }

// AR
export const setArLoading = ({ commit }, isLoading) => { commit('SET_AR_LOADING', isLoading) }

// Glances
export const setGlancedOptionsItem = ({ commit }, item) => { commit('SET_GLANCED_OPTIONS_ITEM', item) }
